<div class="img-container" [ngClass]="classNames">
    <img class="img" [src]="defaultImage" alt="avatar" />
</div>